module.exports = __webpack_public_path__ + "img/zhinengwaihufuwu.b00bbc9f.png";